
<form [formGroup]="checkoutForm" (ngSubmit)="onSubmitDept(checkoutForm.value)" novalidate>
    <div class="container-fluid">
        <div class="row">

            <div class="col-sm-12">
                <label>Nombre del departamento</label>
                <input id="nombre" type="text" formControlName="nombre"><span class="highlight"></span>

            </div>

            <div class="col-sm-12">
                <input [disabled]="checkoutForm.invalid" type="submit" value="Guardar">

            </div>

           
        </div>
    </div>

</form>